import { render } from "./SignageLayouts.vue?vue&type=template&id=b693efe2&scoped=true&ts=true"
import script from "./SignageLayouts.vue?vue&type=script&lang=ts"
export * from "./SignageLayouts.vue?vue&type=script&lang=ts"

import "./SignageLayouts.vue?vue&type=style&index=0&id=b693efe2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b693efe2"]])

export default __exports__